var _path, _rect;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFb = function SvgFb(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9142 7.23948C18.5491 7.50794 17.45 8.33667 16.9294 9.46888C16.6055 10.1809 16.5939 10.2743 16.536 12.4803L16.4782 14.7564L14.2222 14.8265V18.6666H16.536V30.2222H21.2794V18.6783L24.4608 18.6083L24.5881 17.6045C24.6691 17.0442 24.7616 16.1688 24.8079 15.6435L24.8889 14.6981H21.2794V11.8033L21.638 11.4999C21.9735 11.2081 22.0545 11.1964 23.4312 11.1964H24.8658V7.11108L22.6445 7.12276C21.4182 7.13443 20.1919 7.18112 19.9142 7.23948V7.23948Z",
    fill: "#0258FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 29,
    height: 29,
    rx: 2.5,
    stroke: "#7EAAFF",
    strokeWidth: 3
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fb.3d2e07de.svg";
export { ForwardRef as ReactComponent };